import fetch from './fetch'
import axios from 'axios'
import * as order from './Advertisement/order'
import * as plan from './Advertisement/plan'
import * as material from './Advertisement/material'
import * as media from './Advertisement/media.js'
import * as dashboard from './dashboard'
import modules from './modules'
import * as upload from './Advertisement/upload'
import * as accountManagement from './AccountManagement/accountManagement'
import * as financial from './financial/financial'
import * as mediaIndex from './mediFactory/mediaIndex'
import * as materialPackage from './materialPackage/materials'
import * as landingPage from './Advertisement/landingPage'
import * as messageService from './message'
import { encrypt, decrypt } from '@/utils/jsencrypt'

const BASE_URL = 'api'

function init(cb) {
  const url = `${BASE_URL}/getUserInfo`
  axios({
    url,
    method: 'get'
  }).then(result => {
    const data = result.data || {}
    const code = data.code
    if (code === 0) {
      this.setUserState(data.data)
    }
    cb(this.state)
  }).catch(e => {
    cb(this.state)
  })
}
const service = {
  state: {
    user: {}
  },
  fetch,
  init,
  $encrypt: encrypt,
  $decrypt: decrypt,
  ...modules,
  ...dashboard,
  ...order,
  ...plan,
  ...material,
  ...media,
  ...upload,
  ...accountManagement,
  ...financial,
  ...mediaIndex,
  ...materialPackage,
  ...landingPage,
  ...messageService
}

export default service
